import { Outlet } from 'react-router-dom';
import { PageLoader } from 'components/Spin';
import { useAppSelector } from 'app/hooks';
import { selectIsBrandDetailsExist } from 'services/brand/brandSelectors';

function BrandLoader() {
  const isBrandDetailsExist = useAppSelector(selectIsBrandDetailsExist);

  if (!isBrandDetailsExist) {
    return <PageLoader />;
  }

  return <Outlet />;
}

export default BrandLoader;
